import { CursorPaginator, OffsetPaginator, type Paginator } from '@/factories/paginator';
import type { ArgumentsType } from '@vueuse/core';
import type { AxiosStatic } from 'axios';
import MockAdapter from 'axios-mock-adapter';

export function useMock(axios: AxiosStatic) {
	const mock = new MockAdapter(axios, { delayResponse: 250 });

	mock.onAny().passThrough();
}

// MOCK UTILITIES
type MockReplyFunc = ArgumentsType<MockAdapter.RequestHandler['reply']>['0'];

// eslint-disable-next-line
function paginate<T extends object>(paginator: Paginator<T>): MockReplyFunc {
	if (paginator instanceof CursorPaginator) {
		return cursorPaginate(paginator);
	} else if (paginator instanceof OffsetPaginator) {
		return offsetPaginate(paginator);
	}
	throw new Error('paginator not recognized');
}

function cursorPaginate<T extends object>(paginator: CursorPaginator<T>): MockReplyFunc {
	return (config) => {
		const { per_page, cursor } = config.params;
		return {
			status: 200,
			data: paginator.getItems(per_page, cursor),
		};
	};
}

function offsetPaginate<T extends object>(paginator: OffsetPaginator<T>): MockReplyFunc {
	return (config) => {
		const { per_page, page } = config.params;
		return {
			status: 200,
			data: paginator.getItems(page, per_page),
		};
	};
}
